// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.nexus-pulse-subtitle {
  margin-top: 4px;
}

.nexus-pulse-feed {
  background: var(--c-white);
}

.nexus-pulse-feed.insights-panel {
  padding: 16px 20px 0;
}

.nexus-pulse-kpis {
  margin-bottom: 16px;
}

.nexus-pulse-kpi--live {
  position: relative;
}

.nexus-pulse-kpi--live::after {
  content: '';
  position: absolute;
  top: 10px;
  right: 10px;
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: var(--c-black);
  animation: nexus-pulse-dot-beat 2s ease-in-out infinite;
}

/* 7-day activity chart */
.nexus-pulse-activity {
  margin-bottom: 16px;
  padding: 14px 16px;
  border: 1px solid var(--border);
  border-radius: 8px;
  background: var(--c-white);
}

.nexus-pulse-activity-head {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 12px;
}

.nexus-pulse-activity-title {
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: var(--c-black);
}

.nexus-pulse-activity-hint {
  font-size: 10px;
  color: var(--text3);
}

/* Sparkline columns — simple, no distorted SVG */
.nexus-pulse-spark {
  display: flex;
  align-items: flex-end;
  gap: 6px;
  height: 100px;
  padding: 4px 2px 0;
}

.nexus-pulse-spark-col {
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  padding: 0;
  border: none;
  background: transparent;
  cursor: pointer;
  font-family: var(--font);
  border-radius: 6px;
  transition: background 0.12s ease;
}

.nexus-pulse-spark-col:hover,
.nexus-pulse-spark-col.is-active {
  background: var(--c-gray-1, #f8fafc);
}

.nexus-pulse-spark-col.is-latest .nexus-pulse-spark-bar {
  background: var(--c-black);
}

.nexus-pulse-spark-col.is-active .nexus-pulse-spark-bar {
  background: var(--c-black);
}

.nexus-pulse-spark-track {
  width: 100%;
  max-width: 40px;
  height: 72px;
  display: flex;
  align-items: flex-end;
  justify-content: center;
}

.nexus-pulse-spark-bar {
  width: 100%;
  height: var(--bar-h, 20%);
  min-height: 4px;
  border-radius: 4px 4px 2px 2px;
  background: var(--c-gray-2, #cbd5e1);
  transform-origin: bottom center;
  animation: nexus-pulse-bar-grow 0.45s cubic-bezier(0.22, 1, 0.36, 1) backwards;
  animation-delay: calc(var(--bar-i, 0) * 0.05s);
  transition: background 0.15s ease, height 0.2s ease;
}

@keyframes nexus-pulse-bar-grow {
  from {
    transform: scaleY(0);
    opacity: 0.4;
  }
  to {
    transform: scaleY(1);
    opacity: 1;
  }
}

.nexus-pulse-spark-day {
  font-size: 10px;
  font-weight: 500;
  color: var(--text3);
  text-transform: uppercase;
  letter-spacing: 0.03em;
}

.nexus-pulse-spark-col.is-active .nexus-pulse-spark-day,
.nexus-pulse-spark-col.is-latest .nexus-pulse-spark-day {
  color: var(--c-black);
  font-weight: 600;
}

.nexus-pulse-spark-val {
  font-size: 11px;
  font-weight: 600;
  color: var(--text2);
  font-variant-numeric: tabular-nums;
}

.nexus-pulse-spark-col.is-active .nexus-pulse-spark-val {
  color: var(--c-black);
}

.nexus-pulse-breakdown {
  margin-top: 12px;
  padding-top: 12px;
  border-top: 1px solid var(--border);
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.nexus-pulse-breakdown-row {
  display: grid;
  grid-template-columns: 100px 1fr 36px;
  align-items: center;
  gap: 10px;
}

.nexus-pulse-breakdown-label {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 11px;
  color: var(--text2);
}

.nexus-pulse-breakdown-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  flex-shrink: 0;
}

.nexus-pulse-breakdown-bar-wrap {
  height: 6px;
  border-radius: 3px;
  background: var(--c-gray-1, #f1f5f9);
  overflow: hidden;
}

.nexus-pulse-breakdown-bar {
  display: block;
  height: 100%;
  min-width: 2px;
  border-radius: 3px;
  opacity: 0.75;
  transition: width 0.25s ease;
}

.nexus-pulse-breakdown-n {
  font-size: 11px;
  font-weight: 600;
  color: var(--c-black);
  text-align: right;
  font-variant-numeric: tabular-nums;
}

.nexus-pulse-activity--empty {
  min-height: 100px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 6px;
}

.nexus-pulse-activity-empty-msg {
  margin: 0;
  font-size: 12px;
  color: var(--text2);
  line-height: 1.45;
}

.nexus-pulse-spark-day {
  font-size: 9px;
  max-width: 72px;
  text-align: center;
  line-height: 1.2;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.nexus-pulse-group-toggle {
  display: inline-flex;
  border: 1px solid var(--border);
  border-radius: 8px;
  overflow: hidden;
}

.nexus-pulse-group-btn {
  font-family: var(--font);
  font-size: 11px;
  font-weight: 500;
  padding: 6px 12px;
  border: none;
  background: var(--c-white);
  color: var(--text2);
  cursor: pointer;
}

.nexus-pulse-group-btn + .nexus-pulse-group-btn {
  border-left: 1px solid var(--border);
}

.nexus-pulse-group-btn.active {
  background: var(--c-black);
  color: var(--c-white);
}

@keyframes nexus-pulse-dot-beat {
  0%, 100% {
    transform: scale(1);
    opacity: 1;
  }
  50% {
    transform: scale(1.35);
    opacity: 0.55;
  }
}

.nexus-pulse-filters-bar {
  gap: 12px;
}

.nexus-pulse-days-select {
  min-width: 148px;
}

.nexus-pulse-company-pill {
  font-size: 11px;
  padding: 5px 12px;
  border-radius: 20px;
  border: 1px solid var(--border);
  background: var(--c-white);
  color: var(--text2);
  max-width: 280px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* Event table (aligned with Marketing / Insights tables) */
.nexus-pulse-table-panel {
  margin-top: 0;
  border-top: 1px solid var(--border);
}

.nexus-pulse-table-panel .table-wrap {
  border: none;
  border-radius: 0;
}

.nexus-pulse-table thead th {
  position: sticky;
  top: 0;
  z-index: 4;
  background: var(--c-white);
}

.nexus-pulse-group-row td {
  padding: 0 !important;
  background: var(--c-gray-1, #f8fafc);
  border-bottom: 1px solid var(--border);
}

.nexus-pulse-group-label {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: var(--c-black);
}

.nexus-pulse-group-dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: var(--c-black);
  flex-shrink: 0;
  animation: nexus-pulse-dot-beat 2.4s ease-in-out infinite;
}

.nexus-pulse-group-count {
  margin-left: auto;
  font-size: 10px;
  font-weight: 500;
  color: var(--text3);
}

.nexus-pulse-source-pill {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 11px;
  font-weight: 600;
  color: var(--text2);
  white-space: nowrap;
}

.nexus-pulse-source-dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  flex-shrink: 0;
}

.nexus-pulse-event-col {
  min-width: 220px;
}

.nexus-pulse-event-cell {
  display: flex;
  align-items: flex-start;
  gap: 10px;
}

.nexus-pulse-thumb-wrap {
  flex-shrink: 0;
  width: 40px;
  height: 40px;
  border-radius: 6px;
  border: 1px solid var(--border);
  overflow: hidden;
  background: var(--c-gray-1, #f1f5f9);
}

.nexus-pulse-thumb-wrap img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.nexus-pulse-event-text {
  min-width: 0;
  flex: 1 1;
}

.nexus-pulse-event-title {
  font-size: 13px;
  font-weight: 600;
  color: var(--text1);
  line-height: 1.35;
}

.nexus-pulse-event-summary {
  font-size: 12px;
  color: var(--text2);
  margin-top: 2px;
  line-height: 1.4;
}

.nexus-pulse-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  margin-top: 6px;
}

.nexus-pulse-chip {
  font-size: 10px;
  font-weight: 500;
  padding: 2px 6px;
  border-radius: 4px;
  border: 1px solid var(--border);
  background: var(--c-white);
  color: var(--text2);
}

.nexus-pulse-when-cell {
  white-space: nowrap;
  vertical-align: top;
}

.nexus-pulse-when-primary {
  font-size: 12px;
  font-weight: 500;
  color: var(--c-black);
}

.nexus-pulse-when-secondary {
  font-size: 10px;
  color: var(--text3);
  margin-top: 2px;
}

.nexus-pulse-actions-cell {
  width: 1%;
  white-space: nowrap;
  vertical-align: top;
}

.nexus-pulse-row-actions {
  display: flex;
  gap: 6px;
  justify-content: flex-end;
}

.nexus-pulse-tr--live {
  background: rgba(248, 250, 252, 0.9);
}

.nexus-pulse-tr--live .nexus-pulse-source-dot {
  background: var(--c-black);
  box-shadow: 0 0 0 3px rgba(15, 23, 42, 0.08);
}

/* Legacy timeline (unused) */
.nexus-pulse-timeline {
  padding: 4px 12px 20px;
}

.nexus-pulse-date-header {
  position: sticky;
  top: 0;
  z-index: 5;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 12px 8px;
  margin: 4px 0 2px;
  font-size: 11px;
  font-weight: 600;
  color: var(--c-black);
  text-transform: uppercase;
  letter-spacing: 0.04em;
  background: rgba(255, 255, 255, 0.94);
  backdrop-filter: blur(4px);
  border-bottom: 1px solid var(--border);
}

.nexus-pulse-date-header::before {
  content: '';
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: var(--c-black);
  flex-shrink: 0;
  animation: nexus-pulse-dot-beat 2.4s ease-in-out infinite;
}

.nexus-pulse-date-count {
  margin-left: auto;
  font-size: 10px;
  font-weight: 500;
  color: var(--text3);
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.nexus-pulse-card {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 10px 12px 6px;
  border-bottom: none;
  background: transparent;
  box-shadow: none;
  border-radius: 0;
  border: none;
}

.nexus-pulse-card:hover .nexus-pulse-card-body {
  background: var(--c-gray-1, #f8fafc);
}

.nexus-pulse-card-rail {
  display: flex;
  flex-direction: column;
  align-items: center;
  flex-shrink: 0;
  width: 52px;
  padding-top: 2px;
}

.nexus-pulse-dot-col {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 12px;
  min-height: 12px;
}

.nexus-pulse-dot {
  display: block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: var(--text3);
  border: 2px solid var(--c-white);
  box-shadow: 0 0 0 1px var(--border);
  z-index: 2;
  flex-shrink: 0;
}

.nexus-pulse-card--live .nexus-pulse-dot {
  background: var(--c-black);
}

.nexus-pulse-dot-ring {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 8px;
  height: 8px;
  margin: -4px 0 0 -4px;
  border-radius: 50%;
  border: 1px solid var(--c-black);
  pointer-events: none;
  animation: nexus-pulse-ring 2s ease-out infinite;
}

@keyframes nexus-pulse-ring {
  0% {
    transform: scale(1);
    opacity: 0.7;
  }
  100% {
    transform: scale(2.8);
    opacity: 0;
  }
}

.nexus-pulse-dot-line {
  width: 1px;
  flex: 1 1;
  min-height: 24px;
  margin-top: 4px;
  background: var(--border);
}

.nexus-pulse-card-time {
  margin-top: 6px;
  font-size: 10px;
  font-weight: 500;
  color: var(--text3);
  text-align: center;
  line-height: 1.2;
  white-space: nowrap;
}

.nexus-pulse-card-main {
  display: flex;
  gap: 12px;
  flex: 1 1;
  min-width: 0;
  margin-bottom: 4px;
}

.nexus-pulse-card-body {
  flex: 1 1;
  min-width: 0;
  padding: 8px 12px 10px;
  border-radius: 8px;
  border: 1px solid var(--border);
  background: var(--c-white);
  transition: background 0.12s ease;
}

.nexus-pulse-card-preview {
  flex-shrink: 0;
  width: 72px;
  height: 72px;
  border-radius: 8px;
  border: 1px solid var(--border);
  overflow: hidden;
  background: var(--c-gray-1, #f1f5f9);
}

.nexus-pulse-card-preview img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.nexus-pulse-card-meta {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 4px;
}

.nexus-pulse-event-source {
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  color: var(--text2);
}

.nexus-pulse-event-title {
  font-size: 14px;
  font-weight: 600;
  color: var(--text1);
  line-height: 1.35;
  margin: 0 0 4px;
}

.nexus-pulse-event-summary {
  color: var(--text2);
  font-size: 13px;
  margin: 0 0 6px;
  line-height: 1.45;
}

.nexus-pulse-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-bottom: 8px;
}

.nexus-pulse-chip {
  font-size: 10px;
  font-weight: 500;
  padding: 2px 7px;
  border-radius: 4px;
  border: 1px solid var(--border);
  background: var(--c-white);
  color: var(--text2);
}

.nexus-pulse-event-actions {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

/* Loading */
.nexus-pulse-skeleton {
  padding: 16px 20px;
}

.nexus-pulse-skeleton-card {
  height: 72px;
  border-radius: 8px;
  margin-bottom: 8px;
  border: 1px solid var(--border);
  background: linear-gradient(
    90deg,
    var(--c-gray-1, #f1f5f9) 0%,
    var(--c-white) 50%,
    var(--c-gray-1, #f1f5f9) 100%
  );
  background-size: 200% 100%;
  animation: nexus-pulse-shimmer 1.4s ease-in-out infinite;
}

@keyframes nexus-pulse-shimmer {
  0% { background-position: 100% 0; }
  100% { background-position: -100% 0; }
}

.nexus-pulse-empty {
  padding: 56px 24px;
  text-align: center;
  color: var(--text2);
}

.nexus-pulse-empty-pulse-icon {
  display: block;
  margin: 0 auto 16px;
  color: var(--text3);
  animation: nexus-pulse-dot-beat 2s ease-in-out infinite;
}

.nexus-pulse-empty h3 {
  margin: 0 0 8px;
  font-size: 16px;
  color: var(--text1);
}

.nexus-pulse-empty p {
  margin: 0 auto;
  max-width: 520px;
  font-size: 13px;
  line-height: 1.5;
}

@media (max-width: 900px) {
  .nexus-pulse-card {
    gap: 8px;
  }

  .nexus-pulse-card-rail {
    width: 44px;
  }
}

@media (prefers-reduced-motion: reduce) {
  .nexus-pulse-dot-ring,
  .nexus-pulse-date-header::before,
  .nexus-pulse-kpi--live::after,
  .nexus-pulse-empty-pulse-icon,
  .nexus-pulse-spark-bar {
    animation: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/features/nexus/NexusPulse.css"],"names":[],"mappings":"AAAA;EACE,eAAe;AACjB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,0BAA0B;EAC1B,uDAAuD;AACzD;;AAEA,yBAAyB;AACzB;EACE,mBAAmB;EACnB,kBAAkB;EAClB,+BAA+B;EAC/B,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA,iDAAiD;AACjD;EACE,aAAa;EACb,qBAAqB;EACrB,QAAQ;EACR,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,UAAU;EACV,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,wBAAwB;EACxB,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;;EAEE,oCAAoC;AACtC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,eAAe;EACf,YAAY;EACZ,aAAa;EACb,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;EACf,8BAA8B;EAC9B,oCAAoC;EACpC,+BAA+B;EAC/B,8EAA8E;EAC9E,8CAA8C;EAC9C,mDAAmD;AACrD;;AAEA;EACE;IACE,oBAAoB;IACpB,YAAY;EACd;EACA;IACE,oBAAoB;IACpB,UAAU;EACZ;AACF;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;;EAEE,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,kCAAkC;AACpC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,mCAAmC;EACnC,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,oCAAoC;EACpC,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,iBAAiB;EACjB,kCAAkC;AACpC;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,SAAS;EACT,eAAe;EACf,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;EACZ,0BAA0B;EAC1B,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,0BAA0B;EAC1B,qBAAqB;AACvB;;AAEA;EACE;IACE,mBAAmB;IACnB,UAAU;EACZ;EACA;IACE,sBAAsB;IACtB,aAAa;EACf;AACF;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,+BAA+B;EAC/B,0BAA0B;EAC1B,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,2DAA2D;AAC3D;EACE,aAAa;EACb,mCAAmC;AACrC;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,UAAU;EACV,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;EACrB,oCAAoC;EACpC,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,0BAA0B;EAC1B,cAAc;EACd,yDAAyD;AAC3D;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,+BAA+B;EAC/B,gBAAgB;EAChB,oCAAoC;AACtC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,SAAO;AACT;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,+BAA+B;EAC/B,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,0BAA0B;EAC1B,4CAA4C;AAC9C;;AAEA,6BAA6B;AAC7B;EACE,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,sBAAsB;EACtB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,sBAAsB;EACtB,qCAAqC;EACrC,0BAA0B;EAC1B,sCAAsC;AACxC;;AAEA;EACE,WAAW;EACX,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,0BAA0B;EAC1B,cAAc;EACd,yDAAyD;AAC3D;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,cAAc;EACd,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,wBAAwB;EACxB,gCAAgC;EAChC,mCAAmC;EACnC,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,UAAU;EACV,WAAW;EACX,qBAAqB;EACrB,kBAAkB;EAClB,gCAAgC;EAChC,oBAAoB;EACpB,gDAAgD;AAClD;;AAEA;EACE;IACE,mBAAmB;IACnB,YAAY;EACd;EACA;IACE,qBAAqB;IACrB,UAAU;EACZ;AACF;;AAEA;EACE,UAAU;EACV,SAAO;EACP,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,SAAO;EACP,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,+BAA+B;EAC/B,0BAA0B;EAC1B,iCAAiC;AACnC;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,+BAA+B;EAC/B,gBAAgB;EAChB,oCAAoC;AACtC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,+BAA+B;EAC/B,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;;AAEA,YAAY;AACZ;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,+BAA+B;EAC/B;;;;;GAKC;EACD,0BAA0B;EAC1B,wDAAwD;AAC1D;;AAEA;EACE,KAAK,2BAA2B,EAAE;EAClC,OAAO,4BAA4B,EAAE;AACvC;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,mBAAmB;EACnB,uDAAuD;AACzD;;AAEA;EACE,eAAe;EACf,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE;IACE,QAAQ;EACV;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;EACE;;;;;IAKE,eAAe;EACjB;AACF","sourcesContent":[".nexus-pulse-subtitle {\n  margin-top: 4px;\n}\n\n.nexus-pulse-feed {\n  background: var(--c-white);\n}\n\n.nexus-pulse-feed.insights-panel {\n  padding: 16px 20px 0;\n}\n\n.nexus-pulse-kpis {\n  margin-bottom: 16px;\n}\n\n.nexus-pulse-kpi--live {\n  position: relative;\n}\n\n.nexus-pulse-kpi--live::after {\n  content: '';\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  width: 7px;\n  height: 7px;\n  border-radius: 50%;\n  background: var(--c-black);\n  animation: nexus-pulse-dot-beat 2s ease-in-out infinite;\n}\n\n/* 7-day activity chart */\n.nexus-pulse-activity {\n  margin-bottom: 16px;\n  padding: 14px 16px;\n  border: 1px solid var(--border);\n  border-radius: 8px;\n  background: var(--c-white);\n}\n\n.nexus-pulse-activity-head {\n  display: flex;\n  align-items: baseline;\n  justify-content: space-between;\n  gap: 8px;\n  margin-bottom: 12px;\n}\n\n.nexus-pulse-activity-title {\n  font-size: 11px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  color: var(--c-black);\n}\n\n.nexus-pulse-activity-hint {\n  font-size: 10px;\n  color: var(--text3);\n}\n\n/* Sparkline columns — simple, no distorted SVG */\n.nexus-pulse-spark {\n  display: flex;\n  align-items: flex-end;\n  gap: 6px;\n  height: 100px;\n  padding: 4px 2px 0;\n}\n\n.nexus-pulse-spark-col {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 6px;\n  padding: 0;\n  border: none;\n  background: transparent;\n  cursor: pointer;\n  font-family: var(--font);\n  border-radius: 6px;\n  transition: background 0.12s ease;\n}\n\n.nexus-pulse-spark-col:hover,\n.nexus-pulse-spark-col.is-active {\n  background: var(--c-gray-1, #f8fafc);\n}\n\n.nexus-pulse-spark-col.is-latest .nexus-pulse-spark-bar {\n  background: var(--c-black);\n}\n\n.nexus-pulse-spark-col.is-active .nexus-pulse-spark-bar {\n  background: var(--c-black);\n}\n\n.nexus-pulse-spark-track {\n  width: 100%;\n  max-width: 40px;\n  height: 72px;\n  display: flex;\n  align-items: flex-end;\n  justify-content: center;\n}\n\n.nexus-pulse-spark-bar {\n  width: 100%;\n  height: var(--bar-h, 20%);\n  min-height: 4px;\n  border-radius: 4px 4px 2px 2px;\n  background: var(--c-gray-2, #cbd5e1);\n  transform-origin: bottom center;\n  animation: nexus-pulse-bar-grow 0.45s cubic-bezier(0.22, 1, 0.36, 1) backwards;\n  animation-delay: calc(var(--bar-i, 0) * 0.05s);\n  transition: background 0.15s ease, height 0.2s ease;\n}\n\n@keyframes nexus-pulse-bar-grow {\n  from {\n    transform: scaleY(0);\n    opacity: 0.4;\n  }\n  to {\n    transform: scaleY(1);\n    opacity: 1;\n  }\n}\n\n.nexus-pulse-spark-day {\n  font-size: 10px;\n  font-weight: 500;\n  color: var(--text3);\n  text-transform: uppercase;\n  letter-spacing: 0.03em;\n}\n\n.nexus-pulse-spark-col.is-active .nexus-pulse-spark-day,\n.nexus-pulse-spark-col.is-latest .nexus-pulse-spark-day {\n  color: var(--c-black);\n  font-weight: 600;\n}\n\n.nexus-pulse-spark-val {\n  font-size: 11px;\n  font-weight: 600;\n  color: var(--text2);\n  font-variant-numeric: tabular-nums;\n}\n\n.nexus-pulse-spark-col.is-active .nexus-pulse-spark-val {\n  color: var(--c-black);\n}\n\n.nexus-pulse-breakdown {\n  margin-top: 12px;\n  padding-top: 12px;\n  border-top: 1px solid var(--border);\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.nexus-pulse-breakdown-row {\n  display: grid;\n  grid-template-columns: 100px 1fr 36px;\n  align-items: center;\n  gap: 10px;\n}\n\n.nexus-pulse-breakdown-label {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 11px;\n  color: var(--text2);\n}\n\n.nexus-pulse-breakdown-dot {\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n  flex-shrink: 0;\n}\n\n.nexus-pulse-breakdown-bar-wrap {\n  height: 6px;\n  border-radius: 3px;\n  background: var(--c-gray-1, #f1f5f9);\n  overflow: hidden;\n}\n\n.nexus-pulse-breakdown-bar {\n  display: block;\n  height: 100%;\n  min-width: 2px;\n  border-radius: 3px;\n  opacity: 0.75;\n  transition: width 0.25s ease;\n}\n\n.nexus-pulse-breakdown-n {\n  font-size: 11px;\n  font-weight: 600;\n  color: var(--c-black);\n  text-align: right;\n  font-variant-numeric: tabular-nums;\n}\n\n.nexus-pulse-activity--empty {\n  min-height: 100px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  gap: 6px;\n}\n\n.nexus-pulse-activity-empty-msg {\n  margin: 0;\n  font-size: 12px;\n  color: var(--text2);\n  line-height: 1.45;\n}\n\n.nexus-pulse-spark-day {\n  font-size: 9px;\n  max-width: 72px;\n  text-align: center;\n  line-height: 1.2;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.nexus-pulse-group-toggle {\n  display: inline-flex;\n  border: 1px solid var(--border);\n  border-radius: 8px;\n  overflow: hidden;\n}\n\n.nexus-pulse-group-btn {\n  font-family: var(--font);\n  font-size: 11px;\n  font-weight: 500;\n  padding: 6px 12px;\n  border: none;\n  background: var(--c-white);\n  color: var(--text2);\n  cursor: pointer;\n}\n\n.nexus-pulse-group-btn + .nexus-pulse-group-btn {\n  border-left: 1px solid var(--border);\n}\n\n.nexus-pulse-group-btn.active {\n  background: var(--c-black);\n  color: var(--c-white);\n}\n\n@keyframes nexus-pulse-dot-beat {\n  0%, 100% {\n    transform: scale(1);\n    opacity: 1;\n  }\n  50% {\n    transform: scale(1.35);\n    opacity: 0.55;\n  }\n}\n\n.nexus-pulse-filters-bar {\n  gap: 12px;\n}\n\n.nexus-pulse-days-select {\n  min-width: 148px;\n}\n\n.nexus-pulse-company-pill {\n  font-size: 11px;\n  padding: 5px 12px;\n  border-radius: 20px;\n  border: 1px solid var(--border);\n  background: var(--c-white);\n  color: var(--text2);\n  max-width: 280px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n/* Event table (aligned with Marketing / Insights tables) */\n.nexus-pulse-table-panel {\n  margin-top: 0;\n  border-top: 1px solid var(--border);\n}\n\n.nexus-pulse-table-panel .table-wrap {\n  border: none;\n  border-radius: 0;\n}\n\n.nexus-pulse-table thead th {\n  position: sticky;\n  top: 0;\n  z-index: 4;\n  background: var(--c-white);\n}\n\n.nexus-pulse-group-row td {\n  padding: 0 !important;\n  background: var(--c-gray-1, #f8fafc);\n  border-bottom: 1px solid var(--border);\n}\n\n.nexus-pulse-group-label {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 16px;\n  font-size: 11px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  color: var(--c-black);\n}\n\n.nexus-pulse-group-dot {\n  width: 7px;\n  height: 7px;\n  border-radius: 50%;\n  background: var(--c-black);\n  flex-shrink: 0;\n  animation: nexus-pulse-dot-beat 2.4s ease-in-out infinite;\n}\n\n.nexus-pulse-group-count {\n  margin-left: auto;\n  font-size: 10px;\n  font-weight: 500;\n  color: var(--text3);\n}\n\n.nexus-pulse-source-pill {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 11px;\n  font-weight: 600;\n  color: var(--text2);\n  white-space: nowrap;\n}\n\n.nexus-pulse-source-dot {\n  width: 7px;\n  height: 7px;\n  border-radius: 50%;\n  flex-shrink: 0;\n}\n\n.nexus-pulse-event-col {\n  min-width: 220px;\n}\n\n.nexus-pulse-event-cell {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n}\n\n.nexus-pulse-thumb-wrap {\n  flex-shrink: 0;\n  width: 40px;\n  height: 40px;\n  border-radius: 6px;\n  border: 1px solid var(--border);\n  overflow: hidden;\n  background: var(--c-gray-1, #f1f5f9);\n}\n\n.nexus-pulse-thumb-wrap img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  display: block;\n}\n\n.nexus-pulse-event-text {\n  min-width: 0;\n  flex: 1;\n}\n\n.nexus-pulse-event-title {\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--text1);\n  line-height: 1.35;\n}\n\n.nexus-pulse-event-summary {\n  font-size: 12px;\n  color: var(--text2);\n  margin-top: 2px;\n  line-height: 1.4;\n}\n\n.nexus-pulse-chips {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 4px;\n  margin-top: 6px;\n}\n\n.nexus-pulse-chip {\n  font-size: 10px;\n  font-weight: 500;\n  padding: 2px 6px;\n  border-radius: 4px;\n  border: 1px solid var(--border);\n  background: var(--c-white);\n  color: var(--text2);\n}\n\n.nexus-pulse-when-cell {\n  white-space: nowrap;\n  vertical-align: top;\n}\n\n.nexus-pulse-when-primary {\n  font-size: 12px;\n  font-weight: 500;\n  color: var(--c-black);\n}\n\n.nexus-pulse-when-secondary {\n  font-size: 10px;\n  color: var(--text3);\n  margin-top: 2px;\n}\n\n.nexus-pulse-actions-cell {\n  width: 1%;\n  white-space: nowrap;\n  vertical-align: top;\n}\n\n.nexus-pulse-row-actions {\n  display: flex;\n  gap: 6px;\n  justify-content: flex-end;\n}\n\n.nexus-pulse-tr--live {\n  background: rgba(248, 250, 252, 0.9);\n}\n\n.nexus-pulse-tr--live .nexus-pulse-source-dot {\n  background: var(--c-black);\n  box-shadow: 0 0 0 3px rgba(15, 23, 42, 0.08);\n}\n\n/* Legacy timeline (unused) */\n.nexus-pulse-timeline {\n  padding: 4px 12px 20px;\n}\n\n.nexus-pulse-date-header {\n  position: sticky;\n  top: 0;\n  z-index: 5;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 10px 12px 8px;\n  margin: 4px 0 2px;\n  font-size: 11px;\n  font-weight: 600;\n  color: var(--c-black);\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  background: rgba(255, 255, 255, 0.94);\n  backdrop-filter: blur(4px);\n  border-bottom: 1px solid var(--border);\n}\n\n.nexus-pulse-date-header::before {\n  content: '';\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  background: var(--c-black);\n  flex-shrink: 0;\n  animation: nexus-pulse-dot-beat 2.4s ease-in-out infinite;\n}\n\n.nexus-pulse-date-count {\n  margin-left: auto;\n  font-size: 10px;\n  font-weight: 500;\n  color: var(--text3);\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n}\n\n.nexus-pulse-card {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  padding: 10px 12px 6px;\n  border-bottom: none;\n  background: transparent;\n  box-shadow: none;\n  border-radius: 0;\n  border: none;\n}\n\n.nexus-pulse-card:hover .nexus-pulse-card-body {\n  background: var(--c-gray-1, #f8fafc);\n}\n\n.nexus-pulse-card-rail {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  flex-shrink: 0;\n  width: 52px;\n  padding-top: 2px;\n}\n\n.nexus-pulse-dot-col {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: 12px;\n  min-height: 12px;\n}\n\n.nexus-pulse-dot {\n  display: block;\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  background: var(--text3);\n  border: 2px solid var(--c-white);\n  box-shadow: 0 0 0 1px var(--border);\n  z-index: 2;\n  flex-shrink: 0;\n}\n\n.nexus-pulse-card--live .nexus-pulse-dot {\n  background: var(--c-black);\n}\n\n.nexus-pulse-dot-ring {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  width: 8px;\n  height: 8px;\n  margin: -4px 0 0 -4px;\n  border-radius: 50%;\n  border: 1px solid var(--c-black);\n  pointer-events: none;\n  animation: nexus-pulse-ring 2s ease-out infinite;\n}\n\n@keyframes nexus-pulse-ring {\n  0% {\n    transform: scale(1);\n    opacity: 0.7;\n  }\n  100% {\n    transform: scale(2.8);\n    opacity: 0;\n  }\n}\n\n.nexus-pulse-dot-line {\n  width: 1px;\n  flex: 1;\n  min-height: 24px;\n  margin-top: 4px;\n  background: var(--border);\n}\n\n.nexus-pulse-card-time {\n  margin-top: 6px;\n  font-size: 10px;\n  font-weight: 500;\n  color: var(--text3);\n  text-align: center;\n  line-height: 1.2;\n  white-space: nowrap;\n}\n\n.nexus-pulse-card-main {\n  display: flex;\n  gap: 12px;\n  flex: 1;\n  min-width: 0;\n  margin-bottom: 4px;\n}\n\n.nexus-pulse-card-body {\n  flex: 1;\n  min-width: 0;\n  padding: 8px 12px 10px;\n  border-radius: 8px;\n  border: 1px solid var(--border);\n  background: var(--c-white);\n  transition: background 0.12s ease;\n}\n\n.nexus-pulse-card-preview {\n  flex-shrink: 0;\n  width: 72px;\n  height: 72px;\n  border-radius: 8px;\n  border: 1px solid var(--border);\n  overflow: hidden;\n  background: var(--c-gray-1, #f1f5f9);\n}\n\n.nexus-pulse-card-preview img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  display: block;\n}\n\n.nexus-pulse-card-meta {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 8px;\n  margin-bottom: 4px;\n}\n\n.nexus-pulse-event-source {\n  font-size: 11px;\n  font-weight: 600;\n  letter-spacing: 0.02em;\n  text-transform: uppercase;\n  color: var(--text2);\n}\n\n.nexus-pulse-event-title {\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--text1);\n  line-height: 1.35;\n  margin: 0 0 4px;\n}\n\n.nexus-pulse-event-summary {\n  color: var(--text2);\n  font-size: 13px;\n  margin: 0 0 6px;\n  line-height: 1.45;\n}\n\n.nexus-pulse-chips {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n  margin-bottom: 8px;\n}\n\n.nexus-pulse-chip {\n  font-size: 10px;\n  font-weight: 500;\n  padding: 2px 7px;\n  border-radius: 4px;\n  border: 1px solid var(--border);\n  background: var(--c-white);\n  color: var(--text2);\n}\n\n.nexus-pulse-event-actions {\n  display: flex;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n/* Loading */\n.nexus-pulse-skeleton {\n  padding: 16px 20px;\n}\n\n.nexus-pulse-skeleton-card {\n  height: 72px;\n  border-radius: 8px;\n  margin-bottom: 8px;\n  border: 1px solid var(--border);\n  background: linear-gradient(\n    90deg,\n    var(--c-gray-1, #f1f5f9) 0%,\n    var(--c-white) 50%,\n    var(--c-gray-1, #f1f5f9) 100%\n  );\n  background-size: 200% 100%;\n  animation: nexus-pulse-shimmer 1.4s ease-in-out infinite;\n}\n\n@keyframes nexus-pulse-shimmer {\n  0% { background-position: 100% 0; }\n  100% { background-position: -100% 0; }\n}\n\n.nexus-pulse-empty {\n  padding: 56px 24px;\n  text-align: center;\n  color: var(--text2);\n}\n\n.nexus-pulse-empty-pulse-icon {\n  display: block;\n  margin: 0 auto 16px;\n  color: var(--text3);\n  animation: nexus-pulse-dot-beat 2s ease-in-out infinite;\n}\n\n.nexus-pulse-empty h3 {\n  margin: 0 0 8px;\n  font-size: 16px;\n  color: var(--text1);\n}\n\n.nexus-pulse-empty p {\n  margin: 0 auto;\n  max-width: 520px;\n  font-size: 13px;\n  line-height: 1.5;\n}\n\n@media (max-width: 900px) {\n  .nexus-pulse-card {\n    gap: 8px;\n  }\n\n  .nexus-pulse-card-rail {\n    width: 44px;\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .nexus-pulse-dot-ring,\n  .nexus-pulse-date-header::before,\n  .nexus-pulse-kpi--live::after,\n  .nexus-pulse-empty-pulse-icon,\n  .nexus-pulse-spark-bar {\n    animation: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
